export default __webpack_public_path__ + "static/media/esgot-screenshot-04.d94a1585.png";